module.exports = __webpack_public_path__ + "img/we-are-hiring.051b911e.svg";